/* eslint-disable */
import type { LayerSpecification } from 'maplibre-gl';
import type { Theme } from '../definitions/theme';

type Filter = any[];

const geom = (type: 'Polygon' | 'LineString' | 'Point'): Filter => ['==', ['geometry-type'], type];
const kind = (value: string): any => ['==', ['get', 'kind'], value];
const kindDetail = (value: string): Filter => ['==', ['get', 'kind_detail'], value];
const any = (...parts: Filter[]): Filter => ['any', ...parts];
const all = (...parts: Filter[]): any => ['all', ...parts];

/**
 * generate map layers with labels
 */
export function generate_layers_with_labels(source: string, theme: Theme): Array<LayerSpecification> {
    return [
        {
            'id': 'waterway_label',
            'type': 'symbol',
            source,
            'source-layer': 'water',
            'minzoom': 14,
            'filter': all(
                geom('LineString'),
                any(
                    kindDetail('canal'),
                    kindDetail('ditch'),
                    kindDetail('drain'),
                    kindDetail('river'),
                    kindDetail('stream'),
                ),
            ),
            'layout': {
                'symbol-placement': 'line',
                'text-font': ['Open-Sans-Regular'],
                'text-field': ['get', 'name'],
                'text-size': 14,
                'text-letter-spacing': 0.3,
            },
            'paint': {
                'text-color': theme.waterway_label,
                'text-halo-color': theme.waterway_label_halo,
                'text-halo-width': 2,
            },
        },
        {
            'id': 'roads_labels',
            'type': 'symbol',
            source,
            'source-layer': 'roads',
            'filter': all(
                geom('LineString'),
                any(
                    kind('minor_road'),
                    kind('major_road'),
                    kind('highway'),
                    kind('other'),
                ),
            ),
            'layout': {
                'symbol-placement': 'line',
                'text-font': ['Open-Sans-Regular'],
                'text-field': ['get', 'name'],
                'text-size': 12,
            },
            'paint': {
                'text-color': theme.roads_label,
                'text-halo-color': theme.roads_label_halo,
                'text-halo-width': 2,
            },
        },

        // Removed old `mask` layer usage.
        // If you still need a world-mask effect, add it back only after confirming
        // your current tiles actually contain a `mask` source-layer.

        {
            'id': 'ocean_label',
            'type': 'symbol',
            source,
            'source-layer': 'pois',
            'filter': all(
                geom('Point'),
                any(
                    kind('sea'),
                    kind('ocean'),
                ),
            ),
            'layout': {
                'text-font': ['Open-Sans-Regular'],
                'text-field': ['get', 'name'],
                'text-size': 13,
                'text-letter-spacing': 0.1,
            },
            'paint': {
                'text-color': theme.ocean_label,
                'text-halo-color': theme.ocean_label_halo,
                'text-halo-width': 1,
            },
        },
        {
            'id': 'peak_label',
            'type': 'symbol',
            source,
            'source-layer': 'pois',
            'filter': all(
                geom('Point'),
                kind('peak'),
            ),
            'layout': {
                'text-font': ['Open-Sans-Regular'],
                'text-field': ['get', 'name'],
                'text-size': 14,
            },
            'paint': {
                'text-color': theme.peak_label,
                'text-halo-color': theme.peak_label_halo,
                'text-halo-width': 1.5,
            },
        },
        {
            'id': 'places_subplace',
            'type': 'symbol',
            source,
            'source-layer': 'places',
            'filter': kind('neighbourhood'),
            'layout': {
                'text-field': ['get', 'name'],
                'text-font': ['Open-Sans-Regular'],
                'text-transform': 'uppercase',
                'text-size': 14,
            },
            'paint': {
                'text-color': theme.subplace_label,
                'text-halo-color': theme.subplace_label_halo,
                'text-halo-width': 0.5,
            },
        },
        {
            'id': 'places_city_circle',
            'type': 'circle',
            source,
            'source-layer': 'places',
            'filter': kind('city'),
            'paint': {
                'circle-radius': 2,
                'circle-stroke-width': 2,
                'circle-stroke-color': theme.city_circle_stroke,
                'circle-color': theme.city_circle,
            },
            'maxzoom': 8,
        },
    ];
}
